import React, { useEffect, useState } from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import { MasterDataGrid } from "@/components/";

export interface IPropsStep {
    columns: any,
    data: any,
    stepsData: any,
    section: string,
    sectionName: any,
    year: any
}

const NormalIndicator: React.FC<IPropsStep> = ({columns, data, stepsData, section, sectionName, year} : IPropsStep) => {
    const [dataSource, setDataSource] = useState<any>(null);
    const [dataColumns, setDataColumns] = useState<any>(null);

    const view: any = {
        state: {
            columns,
            dataColumns,
            data,
            stepsData,
            year,
            setDataSource,
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    useEffect(() => {
        if(!!data?.length && columns){
            let auxCol = presenter.getIndType1Columns(presenter.formMastersFollowup, section)
            setDataColumns(auxCol)
        }
    }, [data, columns])
   
    return (
        <>
           {!!data?.length && dataColumns &&
                <SingleCollapse title={sectionName} isOpen={false}>
                    <MasterDataGrid
                        id={sectionName}
                        dataSource={dataSource}
                        columns={dataColumns}
                        allowCode={"view"}
                    />     
                </SingleCollapse>
            }
        </>
    )
}

export default NormalIndicator;